import React from 'react';
import { gameConfigStore, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { translationKeys } from '../../enums/translations';
import { touchMeGameId } from '../../enums/gameConstant';

export const HelpPopup = observer(() => {
  const t = useTranslation();
  const { gameId } = gameConfigStore;

  return (
    <div className='c-m-game-rules'>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P1)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P2)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P3)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P4)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P5)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.MinCashOutOdd)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P6)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P7)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P8)}</p>
      {touchMeGameId === +gameId ? (
        <>
          <p className='c-m-game-rules-par'>{t(translationKeys.BONUS)}</p>
          <p className='c-m-game-rules-par'>{t(translationKeys.BONUS_DESC)}</p>
        </>
      ) : (
        <></>
      )}
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P9)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P10)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P12)}</p>
      <p className='c-m-game-rules-par'>{t(translationKeys.GAME_RULES_P11)}</p>
      <p className='c-m-game-rules-par'>
        {t(translationKeys.CANCELATION_MESSAGE_1)}
        <br />
        {t(translationKeys.MALFUNCTION_MESSAGE_2)}
      </p>
      <p className='c-m-game-rules-par'>{t(translationKeys.RTP)}</p>
    </div>
  );
});
